export const SLIDER_COLORS = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3'];
export const GRAPH_MARGIN = { top: 60, right: 50, bottom: 60, left: 70 };

export const MAX_DISPLAYED_POINTS = 30000;
export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 20;
export const ZOOM_STEP = 0.1;
export const PAN_END_BUFFER_FRACTION = 0.4;